import PurchaseData from '../../data/translate';

function getStatus(status) {
  switch (status) {
    case PurchaseData.orderStatus.CONFIRMED:
      return 0;
    case PurchaseData.orderStatus.PROCESSED:
    case PurchaseData.orderStatus.PAID:
    case PurchaseData.orderStatus.FINISHED:
    case PurchaseData.orderStatus.CANCELED:
    case PurchaseData.orderStatus.INVOICES_ISSUED_PARTIALLY:
      return 1;
    case PurchaseData.orderStatus.INVOICES_ISSUED:
      return 2;
    case PurchaseData.orderStatus.ON_CARRIAGE:
      return 3;
    case PurchaseData.orderStatus.DELIVERED:
      return 4;
    default:
      return 0;
  }
}

export default {
  getStatus,
};
